import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { paths } from "./paths";
import PrivateRoute from "./PrivateRoute";
import { useRole } from "../v1/hooks/useRole";

/**
 * PrivateRoute checks only that you're signed in. This also checks *who* you are.
 *
 * Cosmetic by nature — it hides a page, it does not protect data. The server's
 * @require_role is what actually refuses to hand over another tenant's rows. A user
 * who forges localStorage.role gets an empty page full of 403s, which is fine.
 */
const RoleRoute = ({ allow, children }) => {
  const { role } = useRole();
  const location = useLocation();

  return (
    <PrivateRoute>
      {allow.includes(role) ? (
        children
      ) : (
        <Navigate to={paths.v1.jobs} state={{ from: location }} replace />
      )}
    </PrivateRoute>
  );
};

export default RoleRoute;
